import { string, number } from 'yup'
import './methods'

export const fullName = string()
  .required('Full name is required')
  .max(255)
  .trim()
export const firstName = string().required('First name is required')
export const lastName = string().required('Last name is required')

export const email = string()
  .email('Invalid email')
  .required('Email is required')

export const password = string()
  .min(
    8,
    'Your password must have a minimum of 8 characters. Please try another.'
  )
  .max(
    50,
    'Your password must have a maximum of 50 characters. Please try another.'
  )
  .required('Password is required')

export const strongPassword = string()
  .min(
    8,
    'Your password must have a minimum of 8 characters. Please try another.'
  )
  .max(
    50,
    'Your password must have a maximum of 50 characters. Please try another.'
  )
  .minLowercase(1)
  .minUppercase(1)
  .minNumber(1)
  .required('Password is required')

const regExp = /^[0-9()\- ]+$/

export const phone = string()
  .test('validValue', 'Not valid phone number', (value) => regExp.test(value))
  .test(
    'validValue',
    'The value cannot be more than 24 characters',
    (value) => {
      if (value?.length <= 24) return true
    }
  )
  .nullable()
  .required('Phone number is required')

export const country = string().nullable()
export const city = string().nullable()
export const street = string().nullable()
export const zipCode = number().nullable()
